import React from 'react';
import useScrollReveal from '../hooks/useScrollReveal';

const Stats = () => {
  const [ref, revealed] = useScrollReveal(0.2);

  return (
    <section className="py-14 lg:py-20 bg-white" data-testid="stats-section">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-6 lg:px-12 reveal-on-scroll ${revealed ? 'revealed' : ''}`}
      >
        <p className="text-lg lg:text-xl text-slate-600 leading-relaxed text-center" data-testid="stats-intro-line">
          Aus langjähriger Praxis kenne ich die Hebel, mit denen sich Portokosten spürbar und dauerhaft senken lassen — persönlich begleitet, von der Analyse bis zum Regelbetrieb.
        </p>
      </div>
    </section>
  );
};

export default Stats;
